import {fetchGuideCreate} from '@blesk-frontend/api';
import {useMutation} from '@tanstack/react-query';

/**
 * This mutation hook is used to create the Guide.
 */
export const useGuideCreateMutation = () => {
  return useMutation({
    mutationFn: fetchGuideCreate,
  });
};
